import React, { useState, useEffect } from 'react';
import { translatedMessage } from '../../service/LanguageService';
// import { Checkbox } from 'primereact/checkbox';
import GeneralUtils from '../../utilities/GeneralUtils';

const CompetitionJobApprovalViewComponent = (props) => {
    const [competition, setCompetition] = useState(null);

    useEffect(() => {
        setCompetition(props?.competition);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.competition]);

    return (
        <>
            {
                <div className='col-12 mt-5'>
                    <h5 className='mb-1'>{translatedMessage('competition.requirements.jobApproval')}</h5>
                    <div className="w-full grid">
                        <div className='col-4 lg:col-2'>
                            <div className="field-checkbox text-left mb-0 pt-2">
                                {/* <Checkbox inputId="jobApprovalRequired" name="jobApprovalRequired" checked={competition?.jobApprovalRequired} disabled /> */}
                                <label>{translatedMessage("competition.requirements.jobApproval.info") + ": "}</label>
                            </div>
                        </div>
                        <div className='col-8 lg:col-10'>
                            <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.jobApproval)}</div>
                        </div>
                        <div className='col-4 lg:col-2'>
                            <div className="field-checkbox text-left mb-0 pt-2">
                                <label>{translatedMessage("competition.requirements.jobApprovalNormativeAct") + ": "}</label>
                            </div>
                        </div>
                        <div className='col-8 lg:col-10'>
                            <div className='w-full p-2 pcn-panel-border'>{GeneralUtils.dashIfNullForObject(competition?.jobApprovalNormativeAct)}</div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default CompetitionJobApprovalViewComponent;
